import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import CreateBot from "../../components/bots/CreateBot";
import Scrollbar from "../../components/Scrollbar";
import { useTranslation } from "../../hooks/useLocalization";

import useAnalytics from "../../hooks/useAnalytics";

const CreateBotModal = ({ bot, open, setOpen, onComplete }) => {
  const { t } = useTranslation();
  const { name, description, isUpdating } = bot || {};
  const [createBotBridge, setOnSubmit] = useState({ onSubmit: null });
  const { CONSOLE_EVENTS } = useAnalytics();
  const onClose = async () => {
    setOpen(false);
    await CONSOLE_EVENTS.EV_CreateBot.send({ action: 'close' })
  }
  return (
    <Modal show={open} onHide={onClose} size="lg" enforceFocus={false}>
      <Helmet title={t("Blank bot")} />
      <Modal.Header closeButton>{t("Blank bot")}</Modal.Header>
      <div className="modal-body-container ps-dark">
        <Scrollbar>
          <Modal.Body className="m-4">
            <CreateBot
              name={name}
              description={description}
              setOnSubmit={(onSubmit) => setOnSubmit({ onSubmit })}
              onComplete={(bot) => {
                setOpen(false);
                onComplete && onComplete(bot);
              }}
            />
          </Modal.Body>
        </Scrollbar>
      </div>
      <Modal.Footer>
        <Button disabled={!!isUpdating} variant="secondary" onClick={onClose}> {t("Close")}
        </Button>{" "}
        <Button disabled={!!isUpdating} variant="primary"
          onClick={() => {
            createBotBridge.onSubmit();
            window.gtag('event', "bots_new_bot_create")
          }}
        >
          {t("Create Bot")}
        </Button>
      </Modal.Footer>
    </Modal >
  );
};

export default CreateBotModal;
